import { Directive } from 'vue';

const INSTANCE_KEY = Symbol('SearchScrollArea');

interface SearchScrollArea extends HTMLElement {
  [INSTANCE_KEY]: {
    onWheel?: (e: WheelEvent) => void;
  };
}

export const vSearchScrollArea: Directive<SearchScrollArea, boolean> = {
  created(el) {
    el[INSTANCE_KEY] = {};
  },

  mounted(el, binding, vnode) {
    const onTable = binding.value;
    // 取provide数据
    const scrollContainer = (vnode as any).ctx?.provides?.[
      'search~scrollContainer'
    ];

    if (!scrollContainer) {
      return;
    }

    // 鼠标滚轮处理
    el[INSTANCE_KEY].onWheel = (e: WheelEvent) => {
      if (scrollContainer.scroll?.(e, onTable)) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    };

    el.addEventListener('wheel', el[INSTANCE_KEY].onWheel);
  },

  unmounted(el) {
    if (el[INSTANCE_KEY]?.onWheel) {
      el.removeEventListener('wheel', el[INSTANCE_KEY].onWheel);
      Reflect.deleteProperty(el, INSTANCE_KEY);
    }
  }
};
